import { API_CORE } from "../utils/constants";


export async function createOrFetchAnon({ pseudo, uuid }) {
  const res = await fetch(`${API_CORE}/anon/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ pseudo, uuid }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || "Impossible de creer/recuperer l'anonyme");
    error.suggestedPseudo = data.suggested_pseudo;
    throw error;
  }
  return data;
}
